import { CliError, CliErrorCode } from '@wix/cli-error';
import semver from 'semver';
import fetchPackageJson from 'package-json';
import type { IPackageManager } from '@wix/package-manager';

export async function validateForLatestVersion(
  pkgJson: typeof import('../../package.json'),
  packageManager: IPackageManager
): Promise<void> {
  const { version: latestVersion } = await fetchPackageJson(pkgJson.name);

  if (typeof latestVersion !== 'string') {
    throw new CliError({
      code: CliErrorCode.FailedToFetchPackageJson(),
      cause: null,
    });
  }

  if (semver.gt(latestVersion, pkgJson.version)) {
    throw new CliError({
      code: CliErrorCode.LatestVersionOfCreateAppRequired({
        currentVersion: pkgJson.version,
        latestVersion,
        updateCommand: packageManager.getUsage(pkgJson.name),
      }),
      cause: null,
    });
  }
}
